module.exports = __webpack_public_path__ + "img/fast_0.d3921bea.png";